import React from 'react';
import styled from 'styled-components';

const WrapperStyles = styled.div`
    max-width: 1100px;
`;

export default function Wrapper(props) {
    return (
        <WrapperStyles className={props.className + " px-5 mx-auto"}>
            {props.children}
        </WrapperStyles>
    );
}